import {Col, Flex, Form, Image, Input, Row, Typography} from "antd"
import {useTranslations} from "next-intl";
import React, {CSSProperties} from "react";

import Icon, {MailOutlined, MobileOutlined, PhoneOutlined} from "@ant-design/icons";
import {ThemeColors} from "@/src/entities/colors";
import {Constants} from "@/src/lib/constants";

const { Link } = Typography;

import Whatsapp from "@/public/assets/svg/whatsapp.svg";
import LocationPin from "@/public/assets/svg/location-pin-outlined.svg";
import {ThemeService} from "@/src/services/theme";

const ContactComponent = () => {
    const localization = useTranslations('contact');
    const themeColors = ThemeService.getThemeColors()

    const iconStyle: React.CSSProperties = {
        fontSize: 48,
        color: themeColors.menuBarColor
    }

    const contactTitle: CSSProperties = {
        color: "#999",
        textTransform: "uppercase",
        fontSize: 20
    }

    type FieldType = {
        name?: string;
        email?: string
        message?: string;
    };


    return (
        <>
            <Flex vertical gap={16} justify={"center"} align={"center"} style={{margin: "40px 0", padding: "0 24px", textAlign: "center"}}>
                <Typography.Title level={2} className={"sectionTitle"}>{localization("title")}</Typography.Title>
                <Typography.Text  style={{fontSize: 16, color: "#444"}}>{localization("text")}</Typography.Text>
            </Flex>

            <Row gutter={16} style={{margin: 24}}>
                <Col xs={24} sm={8}>
                    <Flex vertical gap={16} justify={"center"} align={"center"}>
                        <Icon component={LocationPin} style={{fontSize: 48, color: "transparent"}} />
                        <Typography.Title level={3} style={contactTitle}>{localization("addressLbl")}</Typography.Title>
                        <Typography.Paragraph style={{marginBottom: 0}}>{Constants.companyFullAddress}</Typography.Paragraph>
                        <Link className={"mapLink"} href={Constants.mapsLink} target={"_blank"}>{localization("findUsLbl")}</Link>
                    </Flex>
                </Col>
                <Col xs={24} sm={8} style={{borderLeft: "1px solid #ddd", borderRight: "1px solid #ddd"}}>
                    <Flex vertical gap={16} justify={"center"} align={"center"}>
                        <MobileOutlined style={iconStyle} />
                        <Typography.Title level={3} style={contactTitle}>{localization("phoneLbl")}</Typography.Title>
                        <Flex vertical={false} gap={4}>
                            <PhoneOutlined rotate={90} style={{fontSize: 16, color: themeColors.menuBarColor}} />
                            <Link className={"mapLink"} href={`tel: ${Constants.companyPhone}`} target={"_blank"}>{Constants.companyPhone}</Link>
                        </Flex>
                        <Flex vertical={false} gap={4}>
                            <Icon component={Whatsapp} style={{fontSize: 16, color: themeColors.menuBarColor}} />
                            <Link className={"mapLink"} href={Constants.whatsappLink} target={"_blank"}>{localization("whatsappLbl")}</Link>
                        </Flex>
                    </Flex>
                </Col>
                <Col xs={24} sm={8}>
                    <Flex vertical gap={16} justify={"center"} align={"center"}>
                        <MailOutlined style={iconStyle} />
                        <Typography.Title level={3} style={contactTitle}>{localization("emailLbl")}</Typography.Title>
                        <Link className={"mapLink"} href={`mailto:${Constants.companyEmail}`}>{Constants.companyEmail}</Link>
                    </Flex>
                </Col>
            </Row>
        </>

    )
}

export default ContactComponent